import React from 'react';
import { Flex } from 'antd';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { Button } from '@mui/material';
import { colors, fonts } from '../../assets/constStyles';
import { paths } from '../../consts';

const ButtonStyled = styled(Button)`
  border-color: ${colors.colorMutedYellow}!important;
  background-color: ${colors.colorMutedYellow}!important;
  color:  white!important;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  padding: 12px 20px!important;
  border-radius: 10px!important;
  font-size: 16px!important;
  font-family: ${fonts.font2};
  
  &:hover {
    border-color: ${colors.colorRed}!important;
    background-color: ${colors.colorRed}!important;
    transition: all 0.3s ease;
  }

  @media (max-width: 768px) {
    padding: 10px 20px!important;
    font-size: 14px!important;
  }
`;

interface IButtonMain {
  text?: string;
  route?: string
}

export const ButtonMainYellow: React.FC<IButtonMain> = ({ text, route }) => (
        <Flex justify={'start'} style={{ width: '100%' }}>
            <Link to={route || paths.MAIN}>
                <ButtonStyled type={'button'} variant="outlined">
                    {text}
                </ButtonStyled>
            </Link>

        </Flex>
);
